import {FC} from 'react';
import {api, useT} from '@kcast-fe/core';
import {Box, Button, Flex} from '@chakra-ui/react';
import {Loader, Modal, useModal} from 'ui-kit';
import FileSaver from 'file-saver';
import {format} from 'date-fns';

const MAX_WIDTH = {base: '796px', smToMd: 'calc(100% - 12px)'};

const DownloadChatSceneFC: FC = () => {
  const downloadMutation = api.users.useDownloadChatMutation();

  const {t} = useT();
  const {closeModal} = useModal();

  const handleDownload = () => {
    downloadMutation.mutate(undefined, {
      onSuccess: (resp) => {
        const dateStr = format(new Date(), 'dd-MM-yyyy HH-mm');
        FileSaver.saveAs(new Blob([resp]), `Messages ${dateStr}.yaml`);
      },
      onError: () => {
        console.error('[File] Download error');
      }
    });
  };

  return (
    <Modal isOpen title={t('actions.downloadChat')} maxW={MAX_WIDTH}>
      <Box p={'16px 24px 0 24px'} data-testid={'download-chat-modal'}>
        <Box color={'{colors.textSecondary}'} lineHeight={'24px'}>
          {t('messages.downloadChat')}
        </Box>

        <Flex pt={'24px'} justifyContent={'flex-end'} gap={'16px'}>
          <Button size={'lg'} variant={'subtle'} onClick={closeModal}>
            {t('actions.cancel')}
          </Button>

          <Button
            size={'lg'}
            w={'215px'}
            variant={'solid'}
            disabled={downloadMutation.isPending}
            onClick={handleDownload}
          >
            {downloadMutation.isPending ? (
              <Loader size={'sm'} color={'{colors.white}'} />
            ) : (
              t('actions.downloadChat')
            )}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
};

export const DownloadChatScene = DownloadChatSceneFC;
